__turbopack_context__.v({
  "container": "DonationImpact-module-scss-module__QMIDMW__container",
  "impact": "DonationImpact-module-scss-module__QMIDMW__impact",
  "smartdistributionlabel": "DonationImpact-module-scss-module__QMIDMW__smartdistributionlabel",
  "wrapper": "DonationImpact-module-scss-module__QMIDMW__wrapper",
});
